import styled from 'styled-components/macro';

export const StyledActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-top: 4rem;
`;
